import i18n from '@/langs'
import type { RouteRecordRaw } from 'vue-router'

const AccountSettingsView = () => import('@/views/Settings/Account/Index.vue')
const ClientFundView = () => import('@/views/ClientFund/Index.vue')
const ClientOverview = () => import('@/views/ClientFund/ClientOverview.vue')
const ClientFundDetail = () => import('@/views/ClientFund/ClientFundDetail.vue')
const OnePagerLayout = () => import('@/layouts/OnePager.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: OnePagerLayout,
    meta: {
      name: i18n.global.t('ui.common.dashboard'),
    },
    children: [
      {
        path: '/',
        name: 'ClientFundView',
        component: ClientFundView,
        meta: {
          name: i18n.global.t('ui.common.fund'),
        },
        children: [
          {
            path: '',
            name: 'ClientOverview',
            component: ClientOverview,
          },
          {
            path: ':entity_id',
            name: 'ClientFundDetail',
            component: ClientFundDetail,
            props: true,
          },
        ],
      },
      {
        path: '/account-settings',
        name: 'AccountSettingsView',
        component: AccountSettingsView,
        meta: {
          name: i18n.global.t('ui.common.account_settings'),
        },
      },
    ],
  },
]

export default routes
